export function MySQLQuickStartPage() {
  return (
    <div className="space-y-10">
      <div className="space-y-4">
        <h1 className="text-4xl font-bold">Quick Start - MySQL Template</h1>
        <p className="text-lg text-muted-foreground max-w-4xl leading-relaxed">
          Get your NestJS MySQL application up and running in minutes.
        </p>
      </div>

      <div className="bg-card border rounded-xl p-8 space-y-6">
        <h2 className="text-2xl font-bold">Prerequisites</h2>
        <ul className="space-y-2 text-muted-foreground">
          <li className="flex gap-2">
            <span className="text-primary">•</span>
            <span>Node.js 18+ installed</span>
          </li>
          <li className="flex gap-2">
            <span className="text-primary">•</span>
            <span>MySQL 8+ server running</span>
          </li>
          <li className="flex gap-2">
            <span className="text-primary">•</span>
            <span>npm or yarn package manager</span>
          </li>
        </ul>
      </div>

      <div className="space-y-6">
        <h2 className="text-2xl font-bold">Installation Steps</h2>
        
        <div className="space-y-4">
          <h3 className="text-xl font-semibold">1. Clone the Repository</h3>
          <pre className="bg-muted p-4 rounded-lg overflow-x-auto">
            <code>git clone https://github.com/ALIRAZA47/template-nestjs-mysql.git{'\n'}cd template-nestjs-mysql</code>
          </pre>
        </div>

        <div className="space-y-4">
          <h3 className="text-xl font-semibold">2. Install Dependencies</h3>
          <pre className="bg-muted p-4 rounded-lg overflow-x-auto">
            <code>npm install</code>
          </pre>
        </div>

        <div className="space-y-4">
          <h3 className="text-xl font-semibold">3. Configure Environment</h3>
          <pre className="bg-muted p-4 rounded-lg overflow-x-auto">
            <code>cp env.sample .env{'\n'}# Edit .env with your MySQL credentials</code>
          </pre>
        </div>

        <div className="space-y-4">
          <h3 className="text-xl font-semibold">4. Run Migrations</h3>
          <pre className="bg-muted p-4 rounded-lg overflow-x-auto">
            <code>npm run migration:run</code>
          </pre>
        </div>

        <div className="space-y-4">
          <h3 className="text-xl font-semibold">5. Start Development Server</h3>
          <pre className="bg-muted p-4 rounded-lg overflow-x-auto">
            <code>npm run start:dev</code>
          </pre>
        </div>

        <div className="bg-primary/5 border-l-4 border-primary rounded-r-lg p-6">
          <p className="text-sm">
            <strong>🎉 Success!</strong> Your application should now be running at{' '}
            <code className="bg-muted px-2 py-1 rounded">http://localhost:3000</code>
          </p>
          <p className="text-sm mt-2">
            API documentation is available at{' '}
            <code className="bg-muted px-2 py-1 rounded">http://localhost:3000/api</code>
          </p>
        </div>
      </div>
    </div>
  )
}

